var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "bg-light" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row align-items-center" }, [
        _c(
          "div",
          { staticClass: "col-2" },
          [
            _c(
              "router-link",
              {
                staticClass: "align-middle",
                attrs: { to: { name: "homepage" } },
              },
              [
                _c("img", {
                  attrs: {
                    src: require("../media/logo_crop.png"),
                    alt: "UNTRR",
                    height: "50px",
                  },
                }),
              ]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "col-8 text-center" }, [
          _c(
            "div",
            { staticClass: "menu" },
            [
              _c("router-link", { attrs: { to: { name: "vignette" } } }, [
                _c("b", [_vm._v(_vm._s(_vm.$tc("vignetteWord", 1)))]),
              ]),
              _c("router-link", { attrs: { to: { name: "toll" } } }, [
                _c("b", [_vm._v(_vm._s(_vm.$tc("tollWord", 0)))]),
              ]),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "col-2 text-right" }, [
          _c(
            "div",
            { staticClass: "nav-icons right-menu" },
            [
              _c("Language"),
              _c("div", { staticClass: "user" }, [
                _c(
                  "div",
                  {
                    staticClass: "user-icon pointer",
                    class: { active: _vm.userMenuState },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleDropdownMenu("useraccount")
                      },
                    },
                  },
                  [_c("span", { staticClass: "icon person-icon" })]
                ),
                _vm.userMenuState
                  ? _c(
                      "ul",
                      {
                        staticClass: "user-menu",
                        on: {
                          mouseleave: function ($event) {
                            return _vm.closeDropdownMenu()
                          },
                          click: function ($event) {
                            return _vm.closeDropdownMenu()
                          },
                        },
                      },
                      [
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "account-data" } } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("account_container_my_account"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "my-cars" } } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("account_container_vehicles"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "my-orders" } } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("account_container_orders"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "profiles" } } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("account_container_profiles"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: "cards" } } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("account_container_cards"))
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("li", { staticClass: "last" }, [
                          _c(
                            "a",
                            {
                              staticClass: "logout pointer",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.doLogout()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("btn_logout")))]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
              _c(
                "router-link",
                { staticClass: "d-flex", attrs: { to: { name: "cart" } } },
                [
                  _c("div", { staticClass: "shopping-cart" }, [
                    _vm.cartCount > 0
                      ? _c("div", { staticClass: "badge-count" }, [
                          _vm._v(" " + _vm._s(_vm.cartCount) + " "),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "icon cart-icon" }),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }